import { Country } from 'library/ts/model/enums/geo/Country';
import { Domain } from 'library/ts/model/enums/web/Domain';
import { LogService } from 'library/ts/utilities/logger/LogService';
import { removeDuplicates } from 'library/ts/utilities/modules/Array';
import { TrueType } from 'library/ts/utilities/modules/enums/TrueType';
import * as StringModule from 'library/ts/utilities/modules/String';
import { hasSubstring } from 'library/ts/utilities/modules/String';
import * as Type from 'library/ts/utilities/modules/Type';
const logger = LogService.create({ prefixes: ['SmartTag:'] });
export const getTopReferrer = () => {
    let url = '';
    try {
        url = window.top.location.href;
    }
    catch (error) {
    }
    if (!url) {
        url = '';
        let tmpWindow = window;
        let i = 0;
        try {
            for (i = 15; (i > 0) && (tmpWindow.parent !== null); i--) {
                if (tmpWindow.location.length > 0) {
                    url = tmpWindow.location;
                }
                if (tmpWindow.document.referrer.length > 0) {
                    if (tmpWindow !== tmpWindow.top)
                        url = tmpWindow.document.referrer;
                }
                tmpWindow = tmpWindow.parent;
            }
        }
        catch (error) {
        }
    }
    return url;
};
export const parser = (myURL = getTopReferrer()) => {
    const urlString = (myURL === undefined ? getTopReferrer() : myURL);
    const out = {
        hash: undefined,
        host: undefined,
        hostname: undefined,
        hostnameShort: undefined,
        path: undefined,
        pathname: undefined,
        port: undefined,
        protocol: undefined,
        search: undefined
    };
    if (!Type.isFunction(document?.createElement)) {
        return out;
    }
    const url = document.createElement('a');
    url.href = urlString;
    out.protocol = url.protocol;
    out.protocol = out.protocol.replace(':', '');
    out.host = url.host;
    out.host = out.host.split(':')[0];
    out.hostname = url.hostname;
    out.hostnameShort = out.hostname;
    if (out.hostnameShort.indexOf('www.') === 0)
        out.hostnameShort.replace('www.', '');
    out.port = url.port;
    out.pathname = url.pathname;
    if (out.pathname.substr(0, 1) !== '/')
        out.pathname = '/' + out.pathname;
    out.path = out.pathname.substring(0, out.pathname.lastIndexOf('/')) + '/';
    out.hash = url.hash;
    out.search = url.search;
    return out;
};
export const removeParam = (param, url) => {
    const urlArray = decodeURI(url).split('?');
    let path = urlArray.length === 1 ? '' : urlArray[1];
    path = path.replace(new RegExp('&?' + param + '\\[\\d*\\]=[\\w]+', 'g'), '');
    path = path.replace(new RegExp('&?' + param + '=[\\w]+', 'g'), '');
    path = path.replace(/^&/, '');
    return urlArray[0]
        +
            (path.length
                ? '?' + path
                : '');
};
export const addParam = (param, val, url, useDecodeURI = false) => {
    if (typeof val === TrueType.OBJECT) {
        if (val.length) {
            return addParam(param + '[]', val.splice(-1, 1)[0], addParam(param, val, url));
        }
        else {
            return url;
        }
    }
    else {
        const urlArray = (useDecodeURI ? decodeURI(url).split('?') : url.split('?'));
        let path = urlArray.length === 1 ? '' : urlArray[1];
        path += path.length
            ? '&'
            : '';
        path += (useDecodeURI ? decodeURI(param + '=' + val) : (param + '=' + val));
        return urlArray[0] + '?' + path;
    }
};
export const replaceParam = (param, val, url, useDecodeURI = false) => {
    let curURL = (useDecodeURI ? decodeURI(url) : url);
    if (getQueryField(param, curURL)) {
        const pattern = new RegExp('\\b(' + name + '=).*?(&|#|$)');
        if (url.search(pattern) >= 0) {
            curURL = url.replace(pattern, '$1' + val + '$2');
        }
    }
    else {
        curURL = addParam(param, val, url, useDecodeURI);
    }
    return curURL;
};
export const hasProtocol = (url = '', protocol = 'http') => {
    return url.split('/')[0].indexOf(protocol.toLowerCase()) !== -1;
};
export const valid = (string) => {
    if (Type.isString(string) === false)
        return false;
    if (string.indexOf('http://localhost') === 0 || string.indexOf('https://localhost') === 0)
        return true;
    try {
        return URL.canParse(string);
    }
    catch (error) {
        return false;
    }
};
export const getFileExtension = (filename, clean = true) => {
    let out = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
    if (Type.isString(out) && clean === true)
        out = out.split('?')[0];
    return out;
};
export const getQueryField = (field, url) => {
    const href = url ? url : window.location.href;
    const reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
    const string = reg.exec(href);
    return string ? (StringModule.trim(string[1]) !== '' ? sanitize(StringModule.trim(string[1])) : null) : undefined;
};
export const queryStringToObject = (url) => {
    if (url.indexOf('?') > -1)
        url = url.split('?')[1];
    const urlParams = {};
    const replacer = ($0, $1, $2, $3) => {
        urlParams[$1] = $3;
        return urlParams;
    };
    url.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'), replacer);
    return urlParams;
};
export const objectToQueryString = (object = {}) => {
    return Object.keys(object)
        .map((key) => {
        return `${key}=${object[key].toString()}`;
    })
        .join('&');
};
export const cacheBust = (url, cacheBust) => {
    if (cacheBust === true) {
        url.indexOf('?') > -1 ? url += '&time=' + new Date().getTime() : url += '?time=' + new Date().getTime();
    }
    return url;
};
export const toHTTPS = (url, all = true) => {
    if (url === undefined)
        return url;
    const query = 'http://';
    const reg = new RegExp(query, (all === true ? 'gi' : ''));
    url = url.replace(reg, 'https://');
    return url;
};
export const urlsToHTTPS = (urls) => {
    if (Type.isArray(urls) === false)
        urls = [urls];
    for (let i = 0; i < urls.length; i++) {
        urls[i] = toHTTPS(urls[i], true);
    }
    return urls;
};
export const isPARA = (domains = []) => {
    return hasSubstring(parser().hostnameShort.toLowerCase(), removeDuplicates([
        Domain.PPLUS,
        Domain.CBSCOM,
        'cbsallaccess.ca',
        'allaccess.com.au',
        'localhost',
        'googleapis.com',
        'ngrok.io'
    ].concat(domains)));
};
export const myDomain = (host = parser()?.host) => {
    for (const key in Domain) {
        const value = Domain[key];
        if (host.includes(value)) {
            return value;
        }
    }
    return undefined;
};
export const originAllowed = (origin = '', allowedOrigins = [
    'localhost',
    'paramountplus.com',
    'cbs.com',
    'tags.tiqcdn.com'
]) => {
    const allowedRegexStr = allowedOrigins.join('|').replace(/\//g, '\/');
    const allowedRegEx = new RegExp(allowedRegexStr);
    return origin.match(allowedRegEx) !== null;
};
export const countryFromURL = (url = getTopReferrer()) => {
    const topURL = url;
    let matchFound = false;
    let outputCountry = undefined;
    const TEST = {
        LOCALHOST: {
            test: [
                'localhost'
            ],
            country: Country.LOCALHOST
        },
        P_PLUS: {
            test: [
                Domain.PPLUS,
                Domain.CBSCOM,
                'googleapis.com',
                'ngrok.io'
            ],
            country: Country.US
        },
        P_PLUS_CA: {
            test: [
                'cbsallaccess.ca',
                'tv.cbs.com/ca'
            ],
            country: Country.CA
        },
        P_PLUS_AU: {
            test: [
                'allaccess.com.au',
                'tv.cbs.com/au'
            ],
            country: Country.AU
        }
    };
    Object.keys(TEST).forEach((key) => {
        const value = TEST[key];
        if (matchFound === false) {
            if (hasSubstring(topURL, value.test)) {
                matchFound = true;
                outputCountry = value.country;
            }
        }
    });
    if (outputCountry === undefined)
        outputCountry = Country.US;
    return outputCountry;
};
export const isIFrame = () => {
    try {
        return window.self !== window.top;
    }
    catch (error) {
        return true;
    }
};
export const reloadPage = (forceGet = true) => {
    if (window.self !== window.top) {
        window.top.location.reload(forceGet);
    }
    else {
        window.location.reload(forceGet);
    }
};
export const isSSL = (url = getTopReferrer()) => {
    return (url.split('://')[0].toLowerCase() === 'https');
};
export const addCacheToken = (url, cacheBust = false) => {
    const token = '%%_TIMESTAMP_%%';
    if (getQueryField('cb', url) === undefined)
        url = addParam('cb', token, url);
    if (cacheBust === true && getQueryField('ts', url) === undefined)
        url = addParam('ts', new Date().getTime(), url);
    return url;
};
export const blindImageLoader = (imageURL) => {
    if (valid(imageURL) === false)
        return;
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.border = 'none';
    img.src = imageURL;
};
export const getHeaders = (request) => {
    return new Promise((resolve, reject) => {
        if (Type.isUndefined(request) || Type.isUndefined(request?.url)) {
            logger.warn('Utilities.URL.getHeaders: ERROR:', 'request:', request);
            reject({ error: 'Empty request URL!' });
        }
        else {
            logger.log('Utilities.URL.getHeaders:', 'request:', request);
        }
        const out = {};
        fetch(request)
            .then((response) => {
            for (const header of response.headers) {
                out[header[0]] = header[1];
            }
            resolve(out);
        })
            .catch((error) => {
            reject(error);
        })
            .finally(() => {
            resolve(out);
        });
    });
};
export const sanitize = (input) => {
    const element = document.createElement('div');
    element.innerText = input;
    return element.innerHTML;
};
export const isFileExtURL = (url, extensions = ['apng', 'avif', 'gif', 'jpg', 'jpeg', 'jfif', 'pjpeg', 'pjp', 'png', 'svg', 'webp']) => {
    if (valid(url)) {
        return hasSubstring(getFileExtension(parser(url).pathname.toLowerCase()), extensions);
    }
    return false;
};
export const convertToRelative = (importURL = '') => {
    const runtimeVO = window?.SmartTag?.runtimeVO;
    const projectInfo = window?.PlayerServicesProjectInfo;
    Object.keys(projectInfo.app_output_dir).forEach((app_name) => {
        const output_dir = projectInfo.app_output_dir[app_name].value;
        if (Type.isDefined(projectInfo.app_output_file[app_name])) {
            Object.keys(projectInfo.app_output_file[app_name]).forEach((file_ext) => {
                Object.keys(projectInfo.app_output_file[app_name][file_ext]).forEach((type) => {
                    Object.keys(projectInfo.app_output_file[app_name][file_ext][type]).forEach((key) => {
                        if (key === 'value') {
                            let dir_file_pattern = output_dir + '/' + projectInfo.app_output_file[app_name][file_ext][type][key];
                            if (dir_file_pattern.indexOf('.css') > -1) {
                                dir_file_pattern = dir_file_pattern.replace('/', '/css/');
                            }
                            if (importURL.indexOf(dir_file_pattern) > -1) {
                                const importURLSplit = importURL.split(dir_file_pattern);
                                let convertedURL = runtimeVO.url.root + dir_file_pattern;
                                if (importURLSplit.length > 1)
                                    convertedURL += importURLSplit[1];
                                importURL = convertedURL;
                            }
                        }
                    });
                });
            });
        }
    });
    let vtgPlayerDirPattern = projectInfo.dependencies.bundle.tag.dir.value + '/' +
        projectInfo.dependencies.bundle.tag.player.dir.output.value + '/' +
        projectInfo.dependencies.bundle.tag.player.version.player_version_token;
    if (vtgPlayerDirPattern.charAt(vtgPlayerDirPattern.length - 1) !== '/')
        vtgPlayerDirPattern = (vtgPlayerDirPattern + '/');
    if (importURL.indexOf(vtgPlayerDirPattern) > -1) {
        const splitURL = importURL.split(vtgPlayerDirPattern);
        importURL = (runtimeVO.url.root + vtgPlayerDirPattern + splitURL[splitURL.length - 1]);
    }
    return importURL;
};
